import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { api } from '@/lib/api/client'
import { supabase } from '@/lib/auth/client'

export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ location }) => {
    const { data: sessionData } = await supabase.auth.getSession()
    if (!sessionData.session) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      })
    }
    // Allow /onboarding through without the profile check (chicken-and-egg).
    if (location.pathname === '/onboarding') return
    const res = await api.v1.profile.$get()
    if (res.status === 404) {
      throw redirect({ to: '/onboarding' })
    }
  },
  component: () => <Outlet />,
})
